'use client'
import { useContextElement } from '@/context/Context'
import Link from 'next/link'
import React, { useEffect, useRef } from 'react'

export default function MobileFooter1({ storeInfo }) {
  const footerRef = useRef(null)
  const { wishList } = useContextElement()

  useEffect(() => {
    const updateFooterHeight = () => {
      if (footerRef.current) {
        const h = footerRef.current.offsetHeight
        document.documentElement.style.setProperty(
          '--mobile-footer-height',
          `${h}px`
        )
      }
    }

    updateFooterHeight()
    window.addEventListener('resize', updateFooterHeight)

    return () => window.removeEventListener('resize', updateFooterHeight)
  }, [])

  return (
    <footer
      ref={footerRef}
      id="footer"
      className="footer-mobile container w-100 px-5 d-block d-md-none bg-body position-fixed"
      style={{ bottom: 0, left: 0, zIndex: 1000 }}
    >
      <div className="row text-center">
        <div
          className={`${storeInfo?.WishlistButtonEnable ? 'col-4' : 'col-6'}`}
        >
          <Link
            href="/"
            className="footer-mobile__link d-flex flex-column align-items-center"
          >
            <svg
              className="d-block"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <use href="#icon_home" />
            </svg>
            <span>Home</span>
          </Link>
        </div>
        {/* <!-- /.col-3 --> */}

        <div
          className={`${storeInfo?.WishlistButtonEnable ? 'col-4' : 'col-6'}`}
        >
          <Link
            href="/product-list"
            className="footer-mobile__link d-flex flex-column align-items-center"
          >
            <svg
              className="d-block"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <use href="#icon_hanger" />
            </svg>
            <span>Shop</span>
          </Link>
        </div>
        {/* <!-- /.col-3 --> */}

        {storeInfo?.WishlistButtonEnable && (
          <div className="col-4">
            <Link
              href="/MemberCenter/account_wishlist"
              className="footer-mobile__link d-flex flex-column align-items-center"
            >
              <div className="position-relative">
                <svg
                  className="d-block"
                  width="18"
                  height="18"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <use href="#icon_heart" />
                </svg>
                <span className="wishlist-amount d-block position-absolute js-wishlist-count">
                  {wishList.length}
                </span>
              </div>
              <span>Wishlist</span>
            </Link>
          </div>
        )}
        {/* <!-- /.col-3 --> */}
      </div>
      {/* <!-- /.row --> */}
    </footer>
  )
}
